import { useState, useEffect, useCallback } from 'react';

const UseGetGoogleRetailVisitorId = () => {
  const [retailVisitorId, setVisitorId] = useState('');

  const handleVisitorIdIsAvailable = useCallback((event) => {
    setVisitorId(event.detail.googleRetailVisitorId);
  }, []);

  useEffect(() => {
    if (retailVisitorId !== '') return undefined;

    if (window.RVN?.googleRetailVisitorId) {
      setVisitorId(window.RVN.googleRetailVisitorId);
      return undefined;
    }

    window.addEventListener('retail-visitor-id-is-available', handleVisitorIdIsAvailable);


    return () => {
      window.removeEventListener('retail-visitor-id-is-available', handleVisitorIdIsAvailable);
    };
  }, [handleVisitorIdIsAvailable, retailVisitorId]);

  return retailVisitorId;
};

export default UseGetGoogleRetailVisitorId;
